export const RELEASING_ANIMATION_HEIGHT = '70%';
export const RELEASING_ANIMATION_WIDTH = '100%';
export const REFRESHING_ANIMATION_HEIGHT = '100%';
export const REFRESHING_ANIMATION_WIDTH = '100%';
export const PULLING_ANIMATION_HEIGHT = '70%';
export const PULLING_ANIMATION_WIDTH = '100%';
